<!-- @format -->
<!--
    Loader with cards (is used for resources list : participants list, campaigns list etc...)
-->

<template>
    <v-card v-for="index in props.count" :key="index" flat class="bg-surface rounded-xl pa-8 my-4">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
    </v-card>
</template>
<script setup>
const props = defineProps({
    count: {
        type: Number,
        default: 5
    }
})
</script>
